import { createContext, useContext, useState } from 'react'

/**
 * "UpdatingContext": context state to track records that are being updated
 */

interface UpdatingContextState {
  // A dict entry has value "true" while a mutation is in progress
  updating: { [sourceId: string]: boolean }

  setUpdating: (sourceId: string, isUpdating: boolean) => void
}

export const UpdatingContext = createContext<UpdatingContextState>({
  updating: {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: no-op default for React context
  setUpdating: () => {},
})

/**
 * This is used to setup the context provider in the aprent component
 */
export const useUpdatingContexState = (): UpdatingContextState => {
  const [updatingContextState, setUpdatingContextState] = useState<
    UpdatingContextState['updating']
  >({})
  return {
    updating: updatingContextState,
    setUpdating: (sourceId, value) =>
      setUpdatingContextState({ ...updatingContextState, [sourceId]: value }),
  }
}

/**
 * A child component can use this hook to access the UpdatingContext
 */
export const useUpdatingContext = () => useContext(UpdatingContext)
